import { Combobox, Row } from "@narmi/design_system";

interface RecipientSelectorProps {
  field: string;
  value: string;
  recipients: API.Recipient[];
  label: string;
  onChange: (recipientId: API.Recipient["id"]) => void;
  onAddRecipientClick: () => void;
  error?: string;
  displayBottomAction?: boolean;
}

const RecipientSelector = ({
  value,
  recipients,
  label,
  onChange,
  onAddRecipientClick,
  displayBottomAction,
  error,
}: RecipientSelectorProps) => {
  // The `Combobox` component allows deselection when clearing the input,
  // which fires `onChange` with an empty string.
  // Consuemrs of this RecipientSelector expect the `onChange` event
  // to fire only when a recipient is selected.
  const handleChange = (c: string) => {
    console.info("handling change!");
    if (c.length >= 1) {
      onChange(c as API.RecipientId);
    }
  };

  return (
    <Combobox label={label} value={value} onChange={handleChange} error={error}>
      {recipients.map((r) => (
        <Combobox.Item key={r.id} value={r.id} searchValue={r.name}>
          <Row gapSize="xxs">
            <Row.Item>{r.name}</Row.Item>
            {r.nickname ? (
              <Row.Item shrink>
                <span className="fontSize--xs fontColor--secondary">
                  {r.nickname}
                </span>
              </Row.Item>
            ) : null}
          </Row>
        </Combobox.Item>
      ))}
      {displayBottomAction && (
        <Combobox.Action
          label="Add a new recipient"
          onSelect={onAddRecipientClick}
        />
      )}
    </Combobox>
  );
};

export default RecipientSelector;
